import { createContext, FC } from 'react';

/**
 * Modal information available to all components.
 */
const ModalContext = createContext(null);
const ModalDispatchContext = createContext<FC>(() => null);

export { ModalContext, ModalDispatchContext };
